/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useLayout } from '../core'

const Footer: FC = () => {
  const { classes } = useLayout()
  return (
    <div className='footer pt-6 pb-9 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div className={`${classes.footerContainer} d-flex flex-column flex-md-row flex-stack`}>
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1 mt-5 mt-md-0'>

          <a href='https://partner.ofindo.de' target='_blank' rel="noreferrer" className='text-muted text-hover-primary fw-bold me-2 fs-6'>
            Ofindo®
          </a>
          <span className='text-gray-400 me-1 fs-6'>Partnerportal</span>
        </div>
        {/* end::Copyright */}

        {/* begin::Menu */}
        <ul className='menu menu-gray-600 menu-hover-primary order-1 small'>
          <li className='menu-item'>
            <a href='https://www.ofindo.de/datenschutz/?plattform=partner' className='px-2 px-md-5' target='_blank' rel="noreferrer">
              Datenschutz
            </a>
          </li>
          <li className='menu-item'>
            <a href='https://www.ofindo.de/impressum/?plattform=partner' className='px-2 px-md-5' target='_blank' rel="noreferrer">
              Impressum
            </a>
          </li>
        </ul>
        {/* end::Menu */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export { Footer }
